export default "__VITE_ASSET__Jt14PR_u__"